const handleHashJump = () => {
	const url = new URL( window.location );

	if ( ! url.hash ) {
		return;
	}

	const target = document.querySelector( url.hash );
	const accordion = target.closest( '.accordion' );

	// Show accordion element immediatly.
	if ( ! accordion ) {
		return;
	}

	setTimeout( () => {
		window.scrollTo( 0, target.parentNode.offsetTop - 100 );
	}, 400 );

	target.classList.add( 'show' );
};

document.addEventListener( 'DOMContentLoaded', handleHashJump );

window.addEventListener( 'hashchange', handleHashJump );
